import axios from "axios";
import React from "react";
import {useMonsterCatalog} from "../contexts/MonsterCatalogContext";
import {DataGrid, GridColDef, GridToolbarContainer, GridToolbarQuickFilter} from "@mui/x-data-grid";
import {Button, Grid, Modal, TextField} from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import {Link, useNavigate} from "react-router-dom";


const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const specColumns: GridColDef[] = [
    {
        field: 'name', headerName: 'Species', headerAlign: "center", minWidth: 200,
        renderCell: (params) => <Link to={`/monsters/species/${params.row.id}`}>{params.value}</Link>
    },
    {field: 'description', headerName: 'Description', headerAlign: "center", minWidth:500}
]

export function MonsterSpeciesList() {
    const {species, refreshSpecies} = useMonsterCatalog()
    const [newSpeciesOpen, setNewSpeciesOpen] = React.useState(false);
    const [nameError, setNameError] = React.useState<string | null>(null);
    const navigate = useNavigate();

    const handleOpenNew = () => setNewSpeciesOpen(true);
    const handleCloseNew = () => { setNewSpeciesOpen(false); setNameError(null); };

    let newSpecies = {name: "", description: ""}

    async function createNewSpecies() {
        try {
            const {data} = await axios.post("/monsters/species", newSpecies)
            refreshSpecies()
            navigate(`/monsters/species/${data.id}`)
        } catch (err: any) {
            if (err?.response?.status === 409) {
                setNameError(err.response.data?.error ?? 'A species with this name already exists.')
            }
        }
    }

    function QuickFilterToolBar() {
        return (
            <GridToolbarContainer>
                <GridToolbarQuickFilter/>
                <Button onClick={handleOpenNew}><PostAddIcon/></Button>
            </GridToolbarContainer>
        )
    }

    return <React.Fragment>
        <Typography variant="h6" component="h6" align="center">Species</Typography>

        <DataGrid slots={{toolbar: QuickFilterToolBar}}
                  autoHeight={true}
                  rows={species}
                  columns={specColumns}
                  getRowId={(row) => row.id}
                  density={"compact"}
                  initialState={{
                      pagination: {
                          paginationModel: {
                              pageSize: 24,
                          },
                      },
                  }}
        />


        <Modal
            open={newSpeciesOpen}
            onClose={handleCloseNew}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <Typography id="modal-modal-title" variant="h5" component="h4">
                    Create New Species
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField fullWidth id='newSpeciesName' label='Name'
                                   error={!!nameError}
                                   helperText={nameError ?? ''}
                                   onChange={(ev) => {
                                       newSpecies.name = ev.target.value
                                       const dupe = (species as any[]).some(s => s.name.toLowerCase() === ev.target.value.toLowerCase())
                                       setNameError(dupe ? 'A species with this name already exists.' : null)
                                   }}/></Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth id='newSpeciesDescription' label='Description'
                                   onChange={(ev) => {
                                       newSpecies.description = ev.target.value
                                   }}/>
                    </Grid>
                </Grid>

                <Container align={"center"}><Button onClick={createNewSpecies} disabled={!!nameError}>Submit</Button></Container>
            </Box>
        </Modal>
    </React.Fragment>

}